module.exports = __webpack_public_path__ + "img/车辆边框.1c06c17f.png";